import { OptionIterator } from "components/input/select/OptionIterator";
import { Option } from "components/input/select/options";
import template from "./selectMultipleCompactHTMLElement.hbs";
import optionsTemplate from "components/input/select/options.hbs";

export class SelectMultipleCompactHTMLElement extends HTMLElement {

    private _input: HTMLSelectElement;
    //Son todas las options
    private _options: Option[] = [];
    //Son las options seleccionadas
    private _selectedOptions: Option[] = [];

    constructor() {
        super();
        let shadowRoot = this.attachShadow({ mode: "open" });
        //Anadimos template HBS
        const templateHBS = document.createElement("template");
        templateHBS.innerHTML = template();
        shadowRoot.appendChild(templateHBS.content.cloneNode(true));

        this._input = shadowRoot.querySelector("select");

        this.bindEvents();
    }

    private bindEvents(): void {
        this._input.addEventListener("change", (evt) => {
            let selected = (evt.target as HTMLSelectElement).selectedOptions;
            this._selectedOptions = [];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < selected.length; i++) {
                this._selectedOptions.push(
                    OptionIterator.find(
                        this._options,
                        (o) => o.value == selected[i].getAttribute("value")),
                );
            }
            this.dispatchEvent(new Event("change"));
        });
    }

    public setOptions(options: Option[], codeInOptionLabel?: boolean) {
        if (options == null) {
            return;
        }
        this._options = options;
        this._input.innerHTML = optionsTemplate({ options, codeInOptionLabel });
        let size = Math.min(options?.length ?? 0, 25);
        this._input.setAttribute("size", size.toString());

        if (!this._input.disabled) {
            this.bindEventDblclickOptions();
        }
    }

    private bindEventDblclickOptions() {
        //Opcion para deseleccionar valores de options cndo solo queda una
        let options = this._input.querySelectorAll("option") as NodeListOf<HTMLOptionElement>;
        options.forEach(opt => {
            opt.addEventListener("dblclick", (evt) => {
                const option = (evt.target) as HTMLOptionElement;
                if (option.selected && (!(option.parentElement as HTMLSelectElement).disabled && !option.disabled)) {
                    option.selected = false;
                    this.dispatchEvent(new Event("change"));
                }
            });
        });
    }

    //Se pasa un array de string con los values
    set data(selectedOptions: Option[]) {
        this._input.querySelectorAll("option").forEach(o => (o as HTMLOptionElement).selected = false);
        for (const option of selectedOptions ?? []) {
            let value = option?.value ?? option;
            (this._input.querySelector('option[value="' + value + '"]') as HTMLOptionElement).selected = true;
        }
    }

    public getLenghtOptionSelected(): number {
        return $(this._input).find(":selected").length;
    }

    //Se devuelve un array de Options
    get data(): Option[] {
        return this._selectedOptions;
    }

    public set readOnly(ro: boolean) {
        this._input.disabled = ro;
        //this.enableDisableOptions(this._options.map(d => d.value), ro);
    }

    public enableOptions(options: Array<string | number>) {
        this.enableDisableOptions(options, false);
    }

    public disableOptions(options: Array<string | number>): boolean {
        let fireDataChanged: boolean = false;
        if (this.data.every(el => options.includes(el.value))) {
            this.data = [];
            //Lanzar evento pq se borra el seleccionado
            fireDataChanged = true;
        }
        this.enableDisableOptions(options, true);
        return fireDataChanged;
    }

    private enableDisableOptions(options: Array<string | number>, disabled: boolean) {
        for (const optionValue of options ?? []) {
            (this._input.querySelector("option[value=" + optionValue + "]") as HTMLOptionElement).disabled = disabled;
        }
    }
}

export function initSelectMultipleCompactHTMLWebComponent() {
    window.customElements.define("s6-select-multiple-compact-html", SelectMultipleCompactHTMLElement);
}
